import React from 'react';
import { Link } from 'react-router-dom';

// Button
import { Button } from 'antd';

// Internals
import FullPageSplash from '../components/FullPageSplash';
import IMAGE from '../img/pages/404/image.svg';

// Icons
import { ArrowLeft } from 'react-feather';

export default function notFound404() {
  return (
    <FullPageSplash
      actions={
        <>
          <Link to="/">
            <Button size="large">
              <ArrowLeft style={{ marginTop: '-0.15rem' }} />
              Go back
            </Button>
          </Link>

          <Link to="/contact-us">
            <Button type="primary" size="large">
              Contact Us
            </Button>
          </Link>
        </>
      }
      backgroundStyles={{
        backgroundImage: `url(${IMAGE})`,
        backgroundColor: '#fff',
        backgroundSize: 'auto',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}
      title="Page not found"
      subTitle="Sorry, the page you are looking for doesn't exist. Try again by double checking the URL
	  and refreshing the page. If the issue persists, you can contact us below and we’ll help
	  you out."
      pageTitle="404 error"
    />
  );
}
